import React from 'react';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Typography } from '@mui/material';
import dayjs from "dayjs";
import theme from '../../theme';

interface DatePickerFieldProps {
  label: string;
  placeholder?: string;
  formik: any;
  name: string;
  required?: boolean;
}

const DatePickerField: React.FC<DatePickerFieldProps> = ({
  label,
  placeholder = "Enter Date",
  formik,
  name,
  required = false
}) => {
  return (
    <>
      <Typography
        sx={{ color: theme.palette.myCustomColor.dark, marginBottom: "10px" }}
        variant="h4"
      >
        {label} {required && <span style={{ color: '#D32F2F' }}>*</span>}
      </Typography>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          value={formik.values[name] ? dayjs(formik.values[name]) : null}
          onChange={(newValue) => {
            formik.setFieldValue(name, newValue ? newValue.format('YYYY-MM-DD') : '');
          }}
          slotProps={{
            textField: {
              placeholder: placeholder,
              error: !!(
                formik?.errors[name] &&
                (formik?.touched[name] || formik?.submitCount > 0)
              ),
              helperText: formik?.errors[name] &&
                (formik?.touched[name] || formik?.submitCount > 0)
                ? formik.errors[name]
                : "",
              fullWidth: true,
              margin: "dense",
              sx: {
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    border: 'none',
                  },
                  '&:hover fieldset': {
                    border: 'none',
                  },
                  '&.Mui-focused fieldset': {
                    border: '2px solid #1976d2',
                  },
                },
              }
            }
          }}
        />
      </LocalizationProvider>
    </>
  );
};

export default DatePickerField;
